/* =====================================================================
   mk-portal-subpage.js  (Shopify theme asset)  -  window.MKPortalSubpage
   MK Supplements customer portal (Skio Customer Portal v3, /a/account/*)

   Subscription page (/a/account/subscriptions/<id>), round 2 spec D:
     1. ONE card headed "Your subscription": Skio's header card (interval,
        edit-frequency pencil, next-order date, price, Get now / Skip / More,
        streak flame) and Skio's products card are drawn as one card by
        assets/mk-portal-subpage.css. This file only adds the headline
        <h2 id="mk-subcard-title">Your subscription</h2> as the first child of
        Skio's header container, after a shape check. Every merged-mode CSS
        rule requires that headline, so the headline IS the switch.
     2. The subline reads "Every month (pencil) . Next order Jun 30 . $40.80":
        Skio's own nodes, reordered by CSS. The only text change: Skio's
        "Next on " in the date button becomes "Next order " (exact match;
        "Resumes on", "Paused", "Cancelled", "Next shipment", 3DS: untouched).
        In the same card the head's "Skip" (skips the whole next order) reads
        "Skip order", so it is not confused with a product row's "Skip"
        (exact match "Skip" in [generic-action-button-skip] only; restorable).
     3. The dark tier strip shows the MK arrowhead for the tier Skio names
        ("Bone" .. "Steel") in place of App Shell's star, once the image
        has loaded (data-mk-tier-art + --mk-tier-art on Skio's tier-info
        element). Independent of 1.
     4. (r8, 1.1.0) Skio's own "Set your next order date" window (Skio's
        next-date-modal, opened by Skio's date button or by Home's
        Change date hand-off): our "In this order" block #mk-datewin goes
        in place of Skio's picture-only banner, between Skio's title and
        calendar (change-date-design DESIGN-NOTES section 9, renders
        fb-before / fb-restyled): each product of the NEXT order with its
        size and quantity, "Currently: Tue, Jun 30" (the order's store
        day, MKPortal.orderDay), Skio's own schedule and price text, and
        one sentence with no charge-day promise (r8 review: "Your next
        order moves to that day" only where this browser's midnight is
        the same store day; east of Chicago Skio's saved midnight is the
        day before in the store's zone, so there the sentence says only
        what follows). Skio's banner is hidden
        by CSS only while our block is in the window. Skio's title,
        calendar, Cancel and Confirm stay Skio's: Skio still saves, we
        never press anything. Skip and Get now windows: unchanged
        (DESIGN-NOTES Q12: later). Independent of 1-3.
   Loaded by snippets/mk-portal.liquid (defer, after the other modules) when
   the switch mk_portal_subpage is on. Needs window.MKPortal (mk-portal-core.js).

   FAIL CLOSED (each part on its own)
   - No headline unless the page has exactly Skio's known shape (header
     container with one row div holding [subscription-header] with an
     interval and the actions; products card in the layout container).
     Shape changed / skeletons / no headline: App Shell's separate cards.
   - Script error: headline removed, "Next on" restored, tier marks removed.
   - React re-creates the header container: the CSS reverts in the same
     frame and the headline is mounted again; more than 5 re-mounts within
     10 s: separate cards for the rest of this page view.
   - Tier name unknown, art URL not a plain https URL, image error, or no
     load within 8 s: App Shell's star.
   - Date window (4): our block only when Skio's window has exactly the
     known shape (one next-date-modal with one skio-modal-dialog, a title,
     a content box holding [subscription-info-banner] then
     [date-picker-calendar], Skio's Confirm, and a banner date "Next on
     Mon D[, YYYY]"), AND a read of this page's subscription (MKPortal.skio,
     read-only) gave an open, not prepaid subscription with lines in its
     next order and a store day, AND that day is the day Skio's own banner
     shows (otherwise one fresh read, then still different = Skio's window
     as Skio draws it). Read failed / shape changed / day differs / more
     than 5 re-mounts in 10 s while the window is open / script error:
     the block is removed, so Skio's banner shows again (the CSS hides it
     only while our block is there).
   - Never moves, removes or re-parents a Skio node; never presses Skio
     buttons; no network except the tier image (an <img> preload) and the
     date window's one read-only Skio read (MKPortal.skio, cached 60 s,
     started once Skio's date button is on the page); no storage; no
     history changes; text-only DOM (MKPortal.el).

   API (only with the gate on)
     MKPortalSubpage.version
     MKPortalSubpage.state() -> {status: 'idle'|'waiting'|'merged'|'native',
         reason, remounts, relabelled ("Next order"), skipRelabelled ("Skip order"),
         tierArt: {web, mobile} (tier key or null),
         header: {interval, next, price} (text of Skio's own nodes) | null,
         dateWindow: {status: 'idle'|'waiting'|'shown'|'native', reason,
             day ('YYYY-MM-DD' shown as "Currently") | null, lines (count),
             remounts}}                                     (r8, 1.1.0)
     MKPortalSubpage.refresh()   re-run the checks now

   CHANGES
     1.1.0 (r8, 2026-10-16)  Skio's "Set your next order date" window gets the
                             "In this order" block (part 4, the fallback that
                             is live for everyone while the change-date
                             pop-up's own save is switched off).
                             r8 review: the note's "moves to that day" only
                             where the browser's midnight is the same store
                             day (DW_COPY.noteNoDay elsewhere); "Currently"
                             prints the year by the store's year.
     1.0.0 (round 2)         parts 1-3.
   ===================================================================== */
(function () {
  'use strict';
  if (window.MKPortalSubpage) return;
  var M = window.MKPortal;
  if (!M || !M.__core || !M.on()) return;
  var CONFIG = (window.MKPortalConfig && typeof window.MKPortalConfig === 'object') ? window.MKPortalConfig : {};
  var MODULES = (CONFIG.modules && typeof CONFIG.modules === 'object') ? CONFIG.modules : {};
  if (MODULES.subpage === false) return;

  var VERSION = '1.1.0';
  /* owner decisions (round 2 spec D, 2026-10-11) */
  var DECISION_MERGE_CARD = true;
  var DECISION_TIER_ART = true;
  var DECISION_RELABEL_NEXT = true;

  var COPY_TITLE = 'Your subscription';
  var TITLE_ID = 'mk-subcard-title';
  var NEXT_FROM = /^(\s*)Next on(?=\s|$)/;
  var NEXT_TO = '$1Next order';
  var NEXT_WHOLE = /^\s*Next on\s+\S/;
  var DECISION_RELABEL_SKIP = true;
  var SKIP_FROM = /^(\s*)Skip(\s*)$/;
  var SKIP_TO = '$1Skip order$2';
  var ROOT_WAIT_MS = 15000;
  var ART_TIMEOUT_MS = 8000;
  var THRASH = { max: 5, windowMs: 10000 };
  var ART_URL = /^https:\/\/[\w.-]+\/[\w\/.%~=&?-]+$/;
  var TIER_SLOTS = [
    ['web', 'loyalty-redeem-banner-web-tier-info', 'loyalty-redeem-banner-web-tier-name'],
    ['mobile', 'loyalty-redeem-banner-mobile-header-tier-info', 'loyalty-redeem-banner-mobile-header-tier-name']
  ];

  var S = {
    status: 'idle', reason: null, remounts: 0, mountTimes: [], mounted: false, unstable: false,
    relabels: [],             /* [{node, original, rewritten}] */
    art: { web: null, mobile: null },
    observer: null, scheduled: false, active: false, run: 0
  };
  var artCache = {};          /* url -> 'ok' | 'fail' | [callbacks] while loading */

  function text(n) { return n ? String(n.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function kids(n) { return n ? Array.prototype.slice.call(n.children || []) : []; }
  function named(n, name) { return !!(n && n.getAttribute && n.getAttribute('data-skio-name') === name); }
  function childByName(parent, name) {
    var k = kids(parent);
    for (var i = 0; i < k.length; i++) if (named(k[i], name)) return k[i];
    return null;
  }
  function plainDiv(n) { return !!(n && n.tagName === 'DIV' && !n.hasAttribute('data-skio-name') && !n.id); }

  /* ------------------------------------------------------------------ */
  /* shape check: everything the CSS relies on, or a reason               */
  /* ------------------------------------------------------------------ */
  function shape() {
    var root = document.getElementById('skio-root');
    var page = root ? M.byName('subscription-details-page', root) : null;
    if (!page) return { ok: false, reason: 'no-page' };
    var hc = childByName(page, 'subscription-details-header-container');
    if (!hc) return { ok: false, reason: 'no-header-container', page: page };
    var rows = kids(hc).filter(function (k) { return k.id !== TITLE_ID; });
    if (rows.length !== 1 || !plainDiv(rows[0])) return { ok: false, reason: 'header-shape', page: page };
    var row = rows[0];
    if (childByName(row, 'subscription-header-skeleton')) return { ok: false, reason: 'loading', page: page };
    var sh = childByName(row, 'subscription-header');
    if (!sh) return { ok: false, reason: 'no-subscription-header', page: page };
    var interval = M.byName('subscription-header-interval', sh);
    if (!interval || !text(interval)) return { ok: false, reason: 'no-interval', page: page };
    var actions = kids(row).filter(function (k) { return plainDiv(k) && childByName(k, 'action-buttons'); });
    if (actions.length !== 1) return { ok: false, reason: 'no-actions', page: page };
    var grid = childByName(page, 'subscription-details-main-grid');
    if (!grid) return { ok: false, reason: 'no-main-grid', page: page };
    var lc = childByName(grid, 'subscription-details-layout-container');
    if (!lc) return { ok: false, reason: 'no-layout-container', page: page };
    var pw = kids(lc).filter(function (k) { return childByName(k, 'products-card') || childByName(k, 'products-card-skeleton'); });
    if (pw.length !== 1) return { ok: false, reason: pw.length ? 'products-shape' : 'no-products-card', page: page };
    if (!childByName(pw[0], 'products-card')) return { ok: false, reason: 'loading', page: page };
    return { ok: true, page: page, hc: hc, row: row, sh: sh };
  }

  function readHeader(page) {
    var sh = page ? M.byName('subscription-header', page) : null;
    if (!sh) return null;
    return {
      interval: text(M.byName('subscription-header-interval', sh)),
      next: text(M.byName('subscription-header-next-date-button', sh)) || text(M.byName('subscription-header-3ds-authorize', sh)),
      price: text(M.byName('subscription-header-price', sh))
    };
  }

  /* ------------------------------------------------------------------ */
  /* "Next on Jun 30" -> "Next order Jun 30" (one text node, restorable)  */
  /* ------------------------------------------------------------------ */
  /* every text node we rewrote (React may re-create the button and later put an old node back),
     newest last; at most RELABEL_KEEP are remembered */
  var RELABEL_KEEP = 12;
  function live(r) { return !!(r && r.node.isConnected && r.node.nodeValue === r.rewritten); }
  function relabelled(kind) {
    for (var i = 0; i < S.relabels.length; i++) if (live(S.relabels[i]) && S.relabels[i].kind === (kind || 'next')) return true;
    return false;
  }
  function restoreRelabel() {
    var list = S.relabels;
    S.relabels = [];
    list.forEach(function (r) {
      try { if (live(r)) r.node.nodeValue = r.original; } catch (e) { /* ignore */ }
    });
  }
  function relabel(hc) {
    if (!DECISION_RELABEL_NEXT) { restoreRelabel(); return; }
    var btn = M.byName('subscription-header-next-date-button', hc);
    if (!btn || !NEXT_WHOLE.test(btn.textContent || '')) return;
    var w = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null), node;
    while ((node = w.nextNode())) {
      var v = node.nodeValue;
      if (!v || !v.trim()) continue;
      if (NEXT_FROM.test(v)) {
        var nv = v.replace(NEXT_FROM, NEXT_TO);
        S.relabels.push({ node: node, original: v, rewritten: nv, kind: 'next' });
        if (S.relabels.length > RELABEL_KEEP) S.relabels.shift();
        node.nodeValue = nv;
      }
      return;   /* only the first text node with content */
    }
  }
  /* the head's "Skip" -> "Skip order" (the button's whole text must be exactly "Skip") */
  function relabelSkip(hc) {
    if (!DECISION_RELABEL_SKIP) return;
    var btn = M.byName('generic-action-button-skip', hc);
    if (!btn || String(btn.textContent || '').trim() !== 'Skip') return;
    var w = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null), node;
    while ((node = w.nextNode())) {
      var v = node.nodeValue;
      if (!v || !v.trim()) continue;
      if (SKIP_FROM.test(v)) {
        var nv = v.replace(SKIP_FROM, SKIP_TO);
        S.relabels.push({ node: node, original: v, rewritten: nv, kind: 'skip' });
        if (S.relabels.length > RELABEL_KEEP) S.relabels.shift();
        node.nodeValue = nv;
      }
      return;
    }
  }

  /* ------------------------------------------------------------------ */
  /* tier art                                                             */
  /* ------------------------------------------------------------------ */
  function preload(url, done) {
    var c = artCache[url];
    if (c === 'ok' || c === 'fail') { done(c === 'ok'); return; }
    if (c) { c.push(done); return; }
    var cbs = artCache[url] = [done];
    var img = new Image(), settled = false, timer = null;
    function fin(ok) {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      img.onload = img.onerror = null;
      artCache[url] = ok ? 'ok' : 'fail';
      cbs.forEach(function (f) { try { f(ok); } catch (e) { /* ignore */ } });
    }
    timer = setTimeout(function () { fin(false); }, ART_TIMEOUT_MS);
    img.onload = function () { fin(img.naturalWidth > 0); };
    img.onerror = function () { fin(false); };
    try { img.decoding = 'async'; img.src = url; } catch (e) { fin(false); }
  }
  function clearArt(info) {
    try {
      if (info.hasAttribute('data-mk-tier-art')) info.removeAttribute('data-mk-tier-art');
      if (info.style.getPropertyValue('--mk-tier-art')) info.style.removeProperty('--mk-tier-art');
    } catch (e) { /* ignore */ }
  }
  function clearAllArt() {
    M.qa('#skio-root [data-mk-tier-art]').forEach(clearArt);
    S.art = { web: null, mobile: null };
  }
  function syncArt(page) {
    TIER_SLOTS.forEach(function (slot) {
      var info = page ? M.byName(slot[1], page) : null;
      if (!info) { S.art[slot[0]] = null; return; }
      var t = DECISION_TIER_ART ? M.tierFor(text(M.byName(slot[2], info))) : null;
      var url = t ? M.tierArt(t.key) : '';
      if (!t || !url || !ART_URL.test(url)) { clearArt(info); S.art[slot[0]] = null; return; }
      if (artCache[url] === 'ok') {
        var v = 'url("' + url + '")';
        if (info.style.getPropertyValue('--mk-tier-art') !== v) info.style.setProperty('--mk-tier-art', v);
        if (info.getAttribute('data-mk-tier-art') !== t.key) info.setAttribute('data-mk-tier-art', t.key);
        S.art[slot[0]] = t.key;
        return;
      }
      clearArt(info);
      S.art[slot[0]] = null;
      if (artCache[url] !== 'fail') preload(url, function () { schedule(); });
    });
  }

  /* ------------------------------------------------------------------ */
  /* (r8) Skio's "Set your next order date" window: "In this order"       */
  /* (change-date-design DESIGN-NOTES section 9; the fallback while the   */
  /* change-date pop-up's own save is off)                                */
  /* ------------------------------------------------------------------ */
  var DECISION_DATE_WINDOW = true;
  var DW_ID = 'mk-datewin';
  var DW_COPY = {
    eyebrow: 'In this order',
    current: 'Currently: ',
    qty: 'Qty ',
    oneTime: ' (this order only)',
    /* no charge-day promise: Skio's window sends midnight in the customer's own time zone, which east of
       Chicago is the day before in the store's zone (research F3, F8); say only what moves */
    note: 'Pick the new day below, then press Confirm. Your next order moves to that day, and orders after it follow your usual schedule.',
    /* r8 review: where Skio's midnight in this browser's zone is NOT the same store day (east of Chicago), Skio's header,
       our card and "Currently" would show the day before the one picked: no "moves to that day" there */
    noteNoDay: 'Pick the new day below, then press Confirm. Orders after it follow your usual schedule.'
  };
  /* Skio's banner date, e.g. "Next on Jun 30" (a year only when it is not this year) */
  var DW_NEXT = /^Next on (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{1,2})(?:, (\d{4}))?$/;
  var DW_MONTHS = 'JanFebMarAprMayJunJulAugSepOctNovDec';
  var DW_SITE_ID = '55c10ac1-455d-48a6-a41e-161371d88114';   /* MK Supplements on Skio (as home / delivery) */
  var DW_TTL_MS = 60000;
  var DW_THRASH = { max: 5, windowMs: 10000 };
  /* read-only; every field is one the live modules already read (delivery's mkDeliverySub, home's mkHome) */
  var DW_Q = [
    'query mkSubpageDateWin($subscriptionId: uuid!, $siteId: uuid!) {',
    '  SubscriptionByPk(id: $subscriptionId) {',
    '    id siteId status statusContext nextBillingDate cyclesCompleted',
    '    skipCycleBillingDate isDigital prepaidGiftRecipientId prepaidDeliveryPolicyId',
    '    BillingPolicy { interval intervalCount maxCycles isMaxCycleV2 }',
    '    SubscriptionLines(where: {removedAt: {_is_null: true}}) {',
    '      id quantity customAttributes isPrepaid ordersRemaining titleOverride',
    '      ProductVariant { title image Product { title imageSrc } }',
    '    }',
    '  }',
    '  SiteByPk(id: $siteId) { id ianaTimezone }',
    '}'
  ].join('\n');

  var DW = {
    active: false, status: 'idle', reason: null, day: null, lines: 0, remounts: 0, times: [], mounted: false, unstable: false,
    data: null,        /* {subId, m: model, at} of the last read for this page */
    pending: null,     /* subId of a read in flight */
    seq: 0, freshFor: null, observer: null, bodyObserver: null, scheduled: false
  };

  function dwDayOf(v, tz) {
    try { return typeof M.orderDay === 'function' ? M.orderDay(v, tz) : M.schedule.siteYmd(v, tz); } catch (e) { return null; }
  }
  /* the read -> {ok: true, day, lines: [{name, variant, qty, oneTime, img}]} | {reason} */
  function dwModel(subId, r) {
    var d = r && !r.errors && r.data && typeof r.data === 'object' ? r.data : null;
    var s = d ? d.SubscriptionByPk : null, site = d ? d.SiteByPk : null;
    if (!s || typeof s !== 'object' || typeof s.id !== 'string' || s.id.toLowerCase() !== String(subId).toLowerCase()) return { reason: 'read' };
    if (typeof s.siteId === 'string' && s.siteId !== DW_SITE_ID) return { reason: 'site' };
    var tz = site && typeof site === 'object' && typeof site.ianaTimezone === 'string' ? site.ianaTimezone : null;
    var day = tz ? dwDayOf(s.nextBillingDate, tz) : null;
    if (!day || !/^\d{4}-\d{2}-\d{2}$/.test(day)) return { reason: 'day' };
    var sub = M.schedule.normalize(s, true);
    if (!sub || !M.schedule.open(sub) || sub.prepaid) return { reason: 'not-open' };
    var raw = (Array.isArray(s.SubscriptionLines) ? s.SubscriptionLines : []).filter(function (l) { return !!M.schedule.normLine(l); });
    if (raw.length !== sub.lines.length) return { reason: 'lines' };
    var lines = M.schedule.linesFor(sub, 1).map(function (l) {
      var x = raw[sub.lines.indexOf(l)] || {}, pv = x.ProductVariant && typeof x.ProductVariant === 'object' ? x.ProductVariant : {};
      var p = pv.Product && typeof pv.Product === 'object' ? pv.Product : {};
      var v = typeof pv.title === 'string' ? pv.title.replace(/\s+/g, ' ').trim().slice(0, 120) : '';
      if (/^default title$/i.test(v) || v === l.title) v = '';
      var img = typeof pv.image === 'string' && pv.image ? pv.image : (typeof p.imageSrc === 'string' ? p.imageSrc : '');
      return { name: l.title, variant: v, qty: l.quantity, oneTime: !!l.oneTime, img: img ? (M.safeUrl(img, { httpsOnly: true, absolute: true }) || '') : '' };
    });
    if (!lines.length) return { reason: 'no-lines' };
    return { ok: true, day: day, tz: tz, lines: lines };
  }
  /* r8 review: does midnight in this browser's zone (what Skio's own window saves for a picked day, research F3) fall
     on the same store day? Checked for the order's day and 1, 4 and 8 weeks on, so a daylight-saving change in the
     coming weeks counts too. Any doubt = false (the sentence without a day promise). */
  function dwMidnightSameDay(ymd, tz) {
    try {
      var y = +ymd.slice(0, 4), mo = +ymd.slice(5, 7) - 1, d = +ymd.slice(8, 10);
      return [0, 7, 28, 56].every(function (k) {
        var x = new Date(y, mo, d + k);
        var want = M.schedule.addYmd ? M.schedule.addYmd(ymd, k) : M.orderDay(new Date(Date.UTC(y, mo, d + k, 12)).toISOString(), 'UTC');
        return !!want && x.getHours() === 0 && dwDayOf(x.toISOString(), tz) === want;
      });
    } catch (e) { return false; }
  }
  function dwLoad(subId, fresh) {
    if (!fresh && DW.pending === subId) return;
    var seq = ++DW.seq, run = S.run;
    DW.pending = subId;
    M.skio(DW_Q, { subscriptionId: subId, siteId: DW_SITE_ID }, { fresh: !!fresh, ttl: DW_TTL_MS }).then(function (r) {
      if (seq !== DW.seq || run !== S.run) return;
      var m;
      try { m = dwModel(subId, r); } catch (e) { m = { reason: 'error' }; }
      DW.pending = null;
      DW.data = { subId: subId, m: m, at: Date.now() };
      dwSchedule();
    }).then(null, function () { if (seq === DW.seq) DW.pending = null; });
  }

  /* Skio's window, when it has exactly the shape we know (else a reason) */
  function dwShape() {
    var portal = document.getElementById('skio-portal');
    if (!portal) return { ok: false, reason: 'no-portal' };
    var modals = M.qa('[data-skio-name="next-date-modal"]', portal);
    if (!modals.length) return { ok: false, reason: 'closed' };
    if (modals.length !== 1) return { ok: false, reason: 'modal-shape' };
    var dlg = M.qa('[data-skio-name="skio-modal-dialog"]', modals[0]);
    if (dlg.length !== 1 || dlg[0].getAttribute('role') !== 'dialog') return { ok: false, reason: 'dialog-shape' };
    if (!text(M.byName('skio-modal-header-title', dlg[0]))) return { ok: false, reason: 'no-title' };
    if (!M.byName('next-date-modal-confirm-button', dlg[0])) return { ok: false, reason: 'no-confirm' };
    var content = M.qa('[data-skio-name="skio-modal-content"]', dlg[0]);
    if (content.length !== 1) return { ok: false, reason: 'content-shape' };
    var k = kids(content[0]).filter(function (n) { return n.id !== DW_ID; });
    if (k.length !== 2 || !named(k[0], 'subscription-info-banner') || !named(k[1], 'date-picker-calendar')) return { ok: false, reason: 'content-shape' };
    var when = text(M.byName('subscription-info-banner-next-date', k[0]));
    var mm = DW_NEXT.exec(when);
    if (!mm) return { ok: false, reason: 'banner-date' };
    return {
      ok: true, content: content[0], banner: k[0], cal: k[1], whenText: when,
      when: { m: DW_MONTHS.indexOf(mm[1]) / 3 + 1, d: +mm[2], y: mm[3] ? +mm[3] : null },
      interval: text(M.byName('subscription-info-banner-interval', k[0])).slice(0, 60),
      price: text(M.byName('subscription-info-banner-price', k[0])).slice(0, 40)
    };
  }
  function dwSameDay(ymd, w) {
    return +ymd.slice(5, 7) === w.m && +ymd.slice(8, 10) === w.d && (w.y === null || +ymd.slice(0, 4) === w.y);
  }
  function dwSig(str) {
    var h = 5381;
    for (var i = 0; i < str.length; i++) h = ((h * 33) ^ str.charCodeAt(i)) >>> 0;
    return 'dw' + h.toString(36) + '.' + str.length;
  }
  function dwBuild(m, s) {
    var E = M.el;
    var items = m.lines.map(function (l) {
      var sub = [l.variant, DW_COPY.qty + l.qty].filter(Boolean).join(' \u00b7 ');
      return E('li', { class: 'mk-dw-line' },
        l.img ? E('img', { src: l.img, alt: '', width: 44, height: 44, decoding: 'async' }) : null,
        E('span', { class: 'mk-dw-text' },
          E('span', { class: 'mk-dw-name', text: l.name + (l.oneTime ? DW_COPY.oneTime : '') }),
          E('span', { class: 'mk-dw-sub', text: sub })));
    });
    var right = [s.interval, s.price].filter(Boolean).join(' \u00b7 ');
    return E('div', { class: 'mk-dw' },
      E('p', { class: 'mk-dw-eyebrow', text: DW_COPY.eyebrow }),
      E('ul', { class: 'mk-dw-lines' }, items),
      E('p', { class: 'mk-dw-row' },
        E('span', { class: 'mk-dw-now' }, DW_COPY.current, E('b', { text: M.formatDate(m.day, 'weekday', { year: 'auto', timeZone: m.tz, now: Date.now() }) })),
        right ? E('span', { class: 'mk-dw-plan', text: right }) : null),
      E('p', { class: 'mk-dw-note', text: dwMidnightSameDay(m.day, m.tz) ? DW_COPY.note : DW_COPY.noteNoDay }));
  }
  function dwUnmount(status, reason) {
    if (document.getElementById(DW_ID)) M.unmount(DW_ID);
    DW.mounted = false;
    DW.status = status;
    DW.reason = reason || null;
    DW.day = null;
    DW.lines = 0;
  }
  /* the window closed: the next opening starts with a clean count */
  function dwClosed() {
    dwUnmount('idle', null);
    DW.remounts = 0;
    DW.times = [];
    DW.unstable = false;
    DW.freshFor = null;
  }
  function dwFailClosed() {
    try { dwUnmount('native', 'error'); } catch (e) { /* ignore */ }
  }

  var dwReconcile = M.guard(function () {
    DW.scheduled = false;
    if (!DW.active) return;
    if (!M.on()) { dwUnmount('native', 'gate-off'); return; }
    if (!DECISION_DATE_WINDOW) { dwUnmount('native', 'decision-off'); return; }
    var r = M.route();
    var subId = r && r.page === 'subscription' ? r.subscriptionId : null;
    if (!subId) { dwUnmount('native', 'route'); return; }
    var s = dwShape();
    if (!s.ok) {
      if (s.reason === 'closed' || s.reason === 'no-portal') dwClosed();
      else dwUnmount('native', s.reason);
      return;
    }
    if (DW.unstable) { dwUnmount('native', 'unstable'); return; }
    var have = DW.data && DW.data.subId === subId ? DW.data : null;
    if (!have) { dwUnmount('waiting', 'loading'); dwLoad(subId, false); return; }
    if (!have.m || !have.m.ok) { dwUnmount('native', have.m ? have.m.reason : 'read'); return; }
    if (!dwSameDay(have.m.day, s.when)) {
      /* our read is older than Skio's window (a change since), or the two disagree: read again once for
         this banner date; until it agrees Skio's window stays as Skio draws it */
      dwUnmount('native', 'day-differs');
      var key = subId + '|' + s.whenText;
      if (DW.freshFor !== key) { DW.freshFor = key; DW.status = 'waiting'; dwLoad(subId, true); }
      return;
    }
    var node = document.getElementById(DW_ID);
    var placed = !!(node && node.parentNode === s.content && node.nextElementSibling === s.cal);
    if (!placed && DW.mounted) {
      var t = Date.now();
      DW.remounts++;
      DW.times = DW.times.filter(function (x) { return t - x < DW_THRASH.windowMs; });
      DW.times.push(t);
      if (DW.times.length > DW_THRASH.max) { DW.unstable = true; dwUnmount('native', 'unstable'); return; }
    }
    var sig = dwSig(JSON.stringify([have.m.day, have.m.lines, s.interval, s.price]));
    var built = M.mount({ id: DW_ID, anchor: s.cal, where: 'before', module: 'subpage', sig: sig, build: function () { return dwBuild(have.m, s); } });
    if (!built) { dwUnmount('native', 'mount-failed'); return; }
    DW.mounted = true;
    DW.status = 'shown';
    DW.reason = null;
    DW.day = have.m.day;
    DW.lines = have.m.lines.length;
  }, dwFailClosed);

  function dwSchedule() {
    if (DW.scheduled || !DW.active) return;
    DW.scheduled = true;
    var run = S.run;
    var go = function () { if (DW.scheduled && run === S.run) dwReconcile(); };
    try { window.requestAnimationFrame(go); } catch (e) { /* no rAF */ }
    setTimeout(go, 200);
  }
  /* our block is gone while it was mounted (React re-drew Skio's window): put it back before the next paint */
  function dwOnRecords(records) {
    if (!DW.active) return;
    var node = document.getElementById(DW_ID);
    for (var i = 0; i < records.length; i++) {
      var tg = records[i].target;
      if (node && tg && (tg === node || node.contains(tg))) continue;
      if (DW.mounted && !node) { dwReconcile(); return; }
      dwSchedule();
      return;
    }
  }
  function dwWatch(portal) {
    if (DW.observer) return;
    DW.observer = new MutationObserver(M.guard(dwOnRecords, dwFailClosed));
    DW.observer.observe(portal, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-skio-name', 'role'] });
    dwSchedule();
  }
  function dwStart() {
    DW.active = true;
    var portal = document.getElementById('skio-portal');
    if (portal) { dwWatch(portal); return; }
    /* Skio adds its portal box on first use: watch <body>'s own children until it is there */
    DW.bodyObserver = new MutationObserver(M.guard(function () {
      var p = document.getElementById('skio-portal');
      if (!p || !DW.active) return;
      if (DW.bodyObserver) { DW.bodyObserver.disconnect(); DW.bodyObserver = null; }
      dwWatch(p);
    }, dwFailClosed));
    DW.bodyObserver.observe(document.body, { childList: true });
  }
  function dwStop() {
    DW.active = false;
    DW.scheduled = false;
    DW.seq++;
    DW.pending = null;
    DW.data = null;
    [DW.observer, DW.bodyObserver].forEach(function (o) { if (o) { try { o.disconnect(); } catch (e) { /* ignore */ } } });
    DW.observer = DW.bodyObserver = null;
    try { dwClosed(); } catch (e) { /* ignore */ }
  }
  /* the read starts once Skio offers its date button on this page (Home's hand-off presses it right after) */
  function dwEarlyRead(page) {
    if (!DW.active || !DECISION_DATE_WINDOW || DW.data || DW.pending) return;
    var r = M.route();
    if (!r || r.page !== 'subscription' || !r.subscriptionId) return;
    if (page && M.byName('subscription-header-next-date-button', page)) dwLoad(r.subscriptionId, false);
  }

  /* ------------------------------------------------------------------ */
  /* the merge                                                            */
  /* ------------------------------------------------------------------ */
  function unmerge(reason) {
    M.unmount(TITLE_ID);
    restoreRelabel();
    S.mounted = false;
    S.status = 'native';
    S.reason = reason || null;
  }
  function failClosed() {
    try { unmerge('error'); } catch (e) { /* ignore */ }
    try { clearAllArt(); } catch (e) { /* ignore */ }
  }

  var reconcile = M.guard(function () {
    if (!S.active) return;
    if (!M.on()) { unmerge('gate-off'); clearAllArt(); return; }
    var s = shape();
    syncArt(s.page || null);
    dwEarlyRead(s.page || null);
    if (!DECISION_MERGE_CARD) { unmerge('decision-off'); return; }
    if (S.unstable) { if (document.getElementById(TITLE_ID)) M.unmount(TITLE_ID); restoreRelabel(); S.status = 'native'; S.reason = 'unstable'; return; }
    if (!s.ok) {
      /* loading (skeletons): keep the current state; the CSS itself drops the merged look while
         Skio shows the products skeleton */
      if (s.reason === 'loading') { if (!S.mounted) { S.status = 'waiting'; S.reason = 'loading'; } return; }
      unmerge(s.reason);
      return;
    }
    var title = document.getElementById(TITLE_ID);
    var placed = !!(title && title.parentNode === s.hc && s.hc.firstElementChild === title);
    if (!placed && S.mounted) {
      var t = Date.now();
      S.remounts++;
      S.mountTimes = S.mountTimes.filter(function (x) { return t - x < THRASH.windowMs; });
      S.mountTimes.push(t);
      if (S.mountTimes.length > THRASH.max) { S.unstable = true; unmerge('unstable'); return; }
    }
    var node = M.mount({
      id: TITLE_ID, anchor: s.hc, where: 'prepend', module: 'subpage', sig: '1',
      build: function () { return M.el('h2', { class: 'mk-subcard-title', text: COPY_TITLE }); }
    });
    if (!node) { unmerge('mount-failed'); return; }
    S.mounted = true;
    S.status = 'merged';
    S.reason = null;
    relabel(s.hc);
    relabelSkip(s.hc);
  }, failClosed);

  function schedule() {
    if (S.scheduled || !S.active) return;
    S.scheduled = true;
    var run = S.run;
    var go = function () { if (!S.scheduled) return; S.scheduled = false; if (run === S.run) reconcile(); };
    try { window.requestAnimationFrame(go); } catch (e) { /* no rAF */ }
    setTimeout(go, 200);   /* background tabs do not run rAF */
  }

  /* our headline is gone while it was mounted (React re-created the container): put it back
     before the next paint, so the separate-cards look never shows for more than this frame */
  function onRecords(records) {
    if (!S.active) return;
    var title = document.getElementById(TITLE_ID);
    for (var i = 0; i < records.length; i++) {
      var tg = records[i].target;
      if (title && tg && (tg === title || title.contains(tg))) continue;
      if (S.mounted && !title) { S.scheduled = false; reconcile(); return; }
      schedule();
      return;
    }
  }

  function stop() {
    S.active = false;
    S.run++;
    dwStop();
    S.scheduled = false;
    if (S.observer) { try { S.observer.disconnect(); } catch (e) { /* ignore */ } S.observer = null; }
    try { unmerge(null); clearAllArt(); } catch (e) { /* ignore */ }
    S.status = 'idle';
    S.reason = null;
  }

  function startPage() {
    stop();
    S.active = true;
    S.unstable = false;
    S.remounts = 0;
    S.mountTimes = [];
    S.status = 'waiting';
    S.reason = 'loading';
    var run = S.run;
    M.waitFor('#skio-root', { timeout: ROOT_WAIT_MS }).then(M.guard(function (root) {
      if (run !== S.run || !S.active) return;
      if (!root) { S.status = 'native'; S.reason = 'no-root'; return; }
      S.observer = new MutationObserver(M.guard(onRecords, failClosed));
      S.observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-skio-name'] });
      reconcile();
      try { dwStart(); } catch (e) { dwFailClosed(); }
    }, failClosed));
  }

  function onRoute(r) {
    if (r && r.page === 'subscription') startPage();
    else stop();
  }

  var api = {
    version: VERSION,
    state: function () {
      var page = null;
      try { page = M.byName('subscription-details-page', document.getElementById('skio-root')); } catch (e) { page = null; }
      return {
        status: S.status, reason: S.reason, remounts: S.remounts, relabelled: relabelled('next'), skipRelabelled: relabelled('skip'),
        tierArt: { web: S.art.web, mobile: S.art.mobile },
        header: S.active && page ? readHeader(page) : null,
        dateWindow: { status: DW.status, reason: DW.reason, day: DW.day, lines: DW.lines, remounts: DW.remounts }
      };
    },
    refresh: function () { S.scheduled = false; reconcile(); dwReconcile(); }
  };
  window.MKPortalSubpage = api;
  M.onRoute(onRoute);
})();
